<template>
  <v-container>
    <v-radio-group
      :rules="[v => !!v || $t('vessel_type_required')]"
      v-model="vesselType"
      :row="$vuetify.breakpoint.smAndUp"
      required
    >
      <v-radio v-for="option in vesselOptions" :key='option.value'
        :label="$t(option.text)"
        :value="option.value"
      />
    </v-radio-group>

    <hr v-if="$vuetify.breakpoint.xs" />

    <v-radio-group
      :row="$vuetify.breakpoint.smAndUp"
      :rules="[v => !!v || $t('request_type_required')]"
      v-model="requestType"
      required
    >
      <v-radio
        v-for="option in requestOptions"
        :key='option.value'
        :label="$t(option.text)"
        :value="option.value"
      />
    </v-radio-group>

    <hr v-if="$vuetify.breakpoint.xs && (requestType != '') && (requestType != 'update')" />

    <v-radio-group
      v-if="categoryRequired()"
      :row="$vuetify.breakpoint.smAndUp"
      :rules="[v => !!v || $t('request_category_required')]"
      v-model="requestCategory"
      required
    >
      <v-radio
        v-for="option in categoryOptions"
        :key='option.value'
        :label="$t(option.text)"
        :value="option.value"
      />
    </v-radio-group>

    <v-text-field
      v-if="voiRequired()"
      :label="$t('voi_number')"
      v-model="requestNumber"
      :rules="[
        v => !!v || $t('voi_number_required'),
        v => /^\d\d\d[-]\d\d$/.test(v) || $t('voi_number_format') + ': XXX-XX']"
      validate-on-blur
      required
      outlined
    ></v-text-field>
  </v-container>
</template>

<script>
import { maocData } from '../../services/MaocData'
export default {
  name: 'request-info',
  watch: {
    vesselType: function () {
      this.emitRequestUpdate()
    },
    requestCategory: function () {
      this.emitRequestUpdate()
    },
    requestType: function () {
      this.emitRequestUpdate()
    }
  },
  data: vm => ({
    vesselType: '',
    requestType: '',
    requestCategory: '',
    requestNumber: '',
    vesselOptions: maocData.asLocalizedSelect('vesselTypes'),
    requestOptions: maocData.asLocalizedSelect('requestTypes'),
    categoryOptions: maocData.asLocalizedSelect('categories')
  }),
  methods: {
    getData: function () {
      return {
        vesselType: this.vesselType,
        requestType: this.requestType,
        requestCategory: this.requestCategory,
        requestNumber: this.requestNumber
      }
    },
    setData: function (data) {
      this.vesselType = data.vesselType
      this.requestType = data.requestType
      this.requestCategory = data.requestCategory
      this.requestNumber = data.requestNumber
    },
    emitRequestUpdate: function () {
      this.$emit('requestUpdated', {
        type: this.vesselType,
        category: this.requestCategory,
        requestType: this.requestType
      })
    },
    categoryRequired: function () {
      return (this.requestType !== '') &&
        ['registration', 'upgrade', 'reactivation'].includes(this.requestType)
    },
    voiRequired: function () {
      return (this.requestType !== '') && this.requestType !== 'registration'
    }
  }
}
</script>
